import { Injectable } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { firstValueFrom, Observable } from 'rxjs';

import PaginationResult from '../../../core/domain/pagination-result';

@Injectable()
export class MsdAiService {
  private readonly testAiCloud: (
    data: unknown,
  ) => Observable<PaginationResult<{ [key: string]: unknown }>>;

  constructor(private functions: AngularFireFunctions) {
    this.testAiCloud = this.functions.httpsCallable<
      unknown,
      PaginationResult<{ [key: string]: unknown }>
    >('msd_ai-testAi');
  }

  async launchTestAI(
    dietitianId: string,
    genre: string,
    age: string,
    repas: string,
    moment: string,
  ): Promise<any> {
    const results = await firstValueFrom(
      this.testAiCloud({ dietitianId, genre, age, repas, moment }),
    );
    return results;
  }
}
